const adjustColors = (color, amount) => {
	const adjusted = color.replace(/^#/, "").replaceAll(/../g, (clr) => {
		const value = Math.min(255, Math.max(0, Number.parseInt(clr, 16) + amount)).toString(16);
		return (`0${value}`).slice(-2);
	});
	return `#${adjusted}`;
};

export default adjustColors;
